"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _info = _interopRequireDefault(require("@assets/info.svg"));
var _button = require("@design/ui/button");
var _RemedyVariantPicker = _interopRequireDefault(require("@common/components/remedy/RemedyVariantPicker"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var REDLINES_INFO_TITLE = "Changes made by the rule to the document.";
function RemedySectionHeader(_ref) {
  var kind = _ref.kind,
    variants = _ref.variants,
    selectedVariantId = _ref.selectedVariantId,
    onVariantSelect = _ref.onVariantSelect,
    onGoToIssue = _ref.onGoToIssue;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "w-full h-6 flex flex-row items-center pr-2 self-stretch flex-none",
    "data-sentry-component": "RemedySectionHeader",
    "data-sentry-source-file": "RemedySectionHeader.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-row items-center px-2 gap-2 h-4 flex-none",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex items-center text-label-sm uppercase tracking-wide text-foreground-muted",
        children: kind === "redlines" ? "Redlines" : "Comment"
      }), kind === "redlines" && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _info.default,
        alt: "Info",
        width: "16",
        height: "16",
        title: REDLINES_INFO_TITLE
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyVariantPicker.default, {
      variants: variants,
      selectedVariantId: selectedVariantId,
      onVariantSelect: onVariantSelect,
      "data-sentry-element": "RemedyVariantPicker",
      "data-sentry-source-file": "RemedySectionHeader.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "link",
      size: "xs",
      onClick: function onClick(e) {
        e.stopPropagation();
        onGoToIssue();
      },
      "data-sentry-element": "Button",
      "data-sentry-source-file": "RemedySectionHeader.tsx",
      children: "Go to issue"
    })]
  });
}
var _default = exports.default = RemedySectionHeader;